import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const query = graphql`
    {
        file(relativePath: {eq: "about.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`

const NewsletterBackground = ({ children }) => {
  const { file: { childImageSharp: { fluid } } } = useStaticQuery(query)

  return (
    <BackgroundImage Tag='div' fluid={fluid} className='signup-section'>
      {children}
    </BackgroundImage>
  )
}

export default NewsletterBackground
